function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M680.1 254.3c-23.6 0-45.7 5.5-65.8 14.9C604.1 198.5 543.7 144 470.2 144c-80.8 0-146.3 65.5-146.3 146.4 0 8 1.1 15.7 2.3 23.3h-2.3c-67.9 0-123 55.1-123 123s55.1 131.5 123 131.5h356.3c86.7 0 156.9-70.2 156.9-156.9s-70.3-157-157-157z",
  fill: "#FFFFFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M680.1 233.1c-17.1 0-34 2.5-50.6 7.6-21.4-68.7-85.9-117.9-159.4-117.9-92.4 0-167.5 75.2-167.5 167.6 0 1.2 0 2.4 0.1 3.6-69.5 10.3-123.1 70.3-123.1 142.7 0 81.3 67.4 152.7 144.2 152.7h356.3c98.2 0 178.2-79.9 178.2-178.1 0-98.3-79.9-178.2-178.2-178.2z m0 313.9H323.8C269.6 547 222 495.4 222 436.7c0-56.1 45.7-101.8 101.8-101.8h2.3c6.2 0 12.1-2.7 16.2-7.5 4-4.7 5.8-11 4.8-17.1-1-6.1-2.1-13.2-2.1-19.9 0-69 56.1-125.2 125.1-125.2 61.3 0 114.3 46 123.2 107 1 6.6 5 12.4 10.9 15.6 5.9 3.2 12.9 3.4 19 0.6 18.4-8.6 37.5-12.9 56.8-12.9 74.8 0 135.7 60.9 135.7 135.7 0.2 74.9-60.7 135.8-135.6 135.8zM331.3 653c-17.6 0-31.8 14.2-31.8 31.8s14.2 31.8 31.8 31.8 31.8-14.2 31.8-31.8c0.1-17.5-14.2-31.8-31.8-31.8zM501 653c-17.5 0-31.8 14.2-31.8 31.8s14.3 31.8 31.8 31.8c17.6 0 31.8-14.2 31.8-31.8 0-17.5-14.2-31.8-31.8-31.8z",
  fill: "#211F1E"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M670.7 684.8m-31.8 0a31.8 31.8 0 1 0 63.6 0 31.8 31.8 0 1 0-63.6 0Z",
  fill: "#211F1E"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M246.5 780.3c-17.6 0-31.8 14.2-31.8 31.8s14.2 31.8 31.8 31.8 31.8-14.2 31.8-31.8-14.2-31.8-31.8-31.8zM416.2 780.3c-17.5 0-31.8 14.2-31.8 31.8s14.3 31.8 31.8 31.8c17.6 0 31.8-14.2 31.8-31.8s-14.2-31.8-31.8-31.8z",
  fill: "#211F1E"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M585.8 812.1m-31.8 0a31.8 31.8 0 1 0 63.6 0 31.8 31.8 0 1 0-63.6 0Z",
  fill: "#211F1E"
});

function SvgHailSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHailSvgrepoCom);
export default __webpack_public_path__ + "static/media/hail-svgrepo-com.f7c5c158.svg";
export { ForwardRef as ReactComponent };